import React from 'react';
import Nav from "../../components/nav";
import Transactions from "../../components/transaction/transactions";

const ListTransaction = () => {
    return (
        <div>
            <Nav/>
            <Transactions/>
        </div>
    );
};

export default ListTransaction;